<div class="row pb-3">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

            <div class="row">
                <div class="col-12">

                    <div class="card" data-toggle="tooltip" data-placement="top" title="{{ 'pages.assets.dashboard.searchfldDesc' | translate }}">
                        <div class="card-body">

                            <form>
                                <div class="form-row">
                                    <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-sm-6 col-xs-12 mb-3">
                                        <label for="src">{{ 'pages.generic.source' | translate }}</label>
                                        <select class="form-control" name="src" aria-describedby="src" [(ngModel)]="source">
                                            <option></option>
                                            <option value="Support">Support</option>
                                        </select>
                                    </div> -->
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="assName">{{ 'pages.generic.name' | translate }}</label>
                                        <input type="text" class="form-control" name="assName" aria-describedby="assName" placeholder="" [(ngModel)]="assetName">
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="assSerial">{{ 'pages.assets.dashboard.fieldTitles.serialNumber' | translate }}</label>
                                        <input type="text" class="form-control" name="assSerial" aria-describedby="assSerial" placeholder="" [(ngModel)]="assetSerialNumber">
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="vendorFilter">{{ 'pages.assets.dashboard.fieldTitles.vendor' | translate }}</label>
                                        <ng-multiselect-dropdown
                                            [settings]="dropdownSettingsVendors"
                                            [data]="vendors"
                                            [(ngModel)]="selectedVendors"
                                            name="vendorFilter"
                                            >
                                        </ng-multiselect-dropdown>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="hostName">{{ 'pages.assets.dashboard.fieldTitles.hostName' | translate }}</label>
                                        <input type="text" class="form-control" name="hostName" aria-describedby="hostName" placeholder="" [(ngModel)]="hostName">
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="alias">{{ 'pages.assets.dashboard.fieldTitles.friendlyName' | translate }}</label>
                                        <input type="text" class="form-control" name="alias" aria-describedby="alias" placeholder="" [(ngModel)]="alias">
                                    </div>
                                </div>
                                
                                <button class="btn btn-primary" (click)="search();">{{ 'pages.generic.filter' | translate }}</button>
                                <button class="btn btn-primary" (click)="reset();">{{ 'pages.generic.reset' | translate }}</button>
                                <button class="btn btn-primary" (click)="exportReport(content);">{{ 'pages.generic.generateReport' | translate }}</button>

                            <ngb-alert *ngIf="fileUploaded" style="margin-top:10px" type="success">{{ 'pages.generic.fileuploaded'  | translate }} </ngb-alert>

                            </form>

                        </div>
                    </div>
                    
                </div>
            </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>

<div class="row rowfiller">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

            <div class="row pt-1">
                <div class="col-12 justify-content-right">
                    <fa-icon [icon]="['fas', 'th-list']" size="2x" class="p-1 click" (click)="changeViewType('list')"></fa-icon>
                    <fa-icon [icon]="['fas', 'th-large']" size="2x" class="p-1 click" (click)="changeViewType('grid')"></fa-icon>
                </div>
            </div>

<!--             <div class="row pt-1">
                <div class="col-12 justify-content-right">
                    <button class="btn btn-primary" (click)="toggleInactive();" *ngIf="includeInactive">{{ 'pages.generic.toggleActive' | translate }}</button>
                    <button class="btn btn-primary" (click)="toggleInactive();" *ngIf="!includeInactive">{{ 'pages.generic.toggleInactive' | translate }}</button>
                </div>
            </div> -->


            <ul class="nav nav-tabs">
                <li class="nav-item" data-toggle="tooltip" data-placement="top" title="{{ 'pages.assets.dashboard.assetContractDesc' | translate }}">
                    <a class="nav-link" [ngClass]="{ 'active' : page === 'assets' }" (click)="page = 'assets'; loadAssets();">{{ 'pages.assets.dashboard.assets' | translate }}</a>
                </li> 
                <li class="nav-item" data-toggle="tooltip" data-placement="top" title="{{ 'pages.assets.dashboard.assetFlagDesc' | translate }}">
                    <a class="nav-link" [ngClass]="{ 'active' : page === 'flagged' }" (click)="loadFlagged();" >{{ 'pages.generic.flagged' | translate }} <span class="badge badge-primary ml-2" style="padding:0.1rem 0.5rem;" *ngIf="flagRefs">{{flagRefs.length}}</span> </a>
                </li>
            </ul>

            <br/><br/>

            <div class="card-body p-t-1 p-3" *ngIf="viewType === 'list' && (page === 'assets' || page === 'flagged')">
                <app-asset-list [assets]="subsetAssets" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="assetsLoaded" (flagEmitter)="flag($event);" (sortEmitter)="sortAssets($event);"></app-asset-list>
            </div>

            <div class="card-body p-t-1 p-3" *ngIf="viewType === 'grid' && (page === 'assets' || page === 'flagged')">
                <app-asset-grid [assets]="subsetAssets" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="assetsLoaded" (flagEmitter)="flag($event);"></app-asset-grid>
            </div>

            <div class="card-body justify-content-center p-t-1 p-3" *ngIf="(page === 'assets' || page === 'flagged') && assetsLoaded">
                <ngb-pagination [collectionSize]="assets.length" pageSize="12" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious></ng-template>
                    <ng-template ngbPaginationNext></ng-template>
                </ngb-pagination>
            </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'pages.generic.generateReport' | translate }}</h5>
    </div>
    <div class="modal-body">
        <div class="form-group col-12 pt-2">
            <label for="contact">{{ 'pages.generic.reportName' | translate }}</label>
            <input type="text" class="form-control" name="PDFName" aria-describedby="PDFName" [(ngModel)]="PDFName">
        </div>
        <div class="row">
            <div class="col-6">
                <select class="form-control" name="reportOpt" aria-describedby="reportOpt" [(ngModel)]="reportOption">
                    <option value="pdf">PDF</option>
                    <option value="csv">CSV</option>
                </select>
            </div>
            <div class="col-6">
                <select class="form-control" name="reportLevel" aria-describedby="reportLevel" [(ngModel)]="pdfAccessLevel">
                    <option title="{{ 'pages.generic.ACCESS_INTERNAL_REPORTS' | translate }}" value="0">{{ 'pages.generic.internal' | translate }}</option>
                    <option title="{{ 'pages.generic.ACCESS_CONFIDENTIAL_REPORTS' | translate }}" value="1">{{ 'pages.generic.confidential' | translate }}</option>
                    <option title="{{ 'pages.generic.ACCESS_RESTRICTED_REPORTS' | translate }}" value="2">{{ 'pages.generic.restricted' | translate }}</option>
            </select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">{{ 'pages.generic.close' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="modal.close('save')">{{ 'pages.generic.save' | translate }}</button>
    </div>
</ng-template>